import React from "react";
import { CalendarItem } from "./CalendarItem";

/** Identifies one occurrence chip (a session can appear on many dates). */
export const occurrenceKey = (item: CalendarItem) => `${item.bookingId}-${item.date}`;

/**
 * The drag surface both calendar views bind to: which chip is lifted, which day
 * is the current drop target, and the handlers that move an occurrence.
 */
export interface OccurrenceDrag {
  /** Key of the chip currently being dragged, for its lifted styling. */
  draggingKey: string | null;
  /** YYYY-MM-DD of the day column under the pointer, for the drop highlight. */
  dragOverYmd: string | null;
  /** True while a reschedule is in flight — the grid dims rather than jumping. */
  isRescheduling: boolean;
  /** Only an active occurrence can be moved; a cancelled one has nothing to reschedule. */
  canDrag: (item: CalendarItem) => boolean;
  handleDragStart: (item: CalendarItem, event: React.DragEvent) => void;
  handleDragEnd: () => void;
  handleDayDragOver: (day: Date, event: React.DragEvent) => void;
  handleDayDragLeave: (day: Date) => void;
  handleDayDrop: (day: Date, event: React.DragEvent) => void;
}
